import Meta from 'src/components/meta/Meta';

const SellSuccessMeta = () => <Meta
  title="Successful Pending Sell | Property Investment | BrickX"
/>;

export default SellSuccessMeta;
